<template>
  <div class="page-container">
    <!-- Overlay de carregamento -->
    <v-overlay v-model="isLoading">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

    <!-- Card principal do formulário -->
    <v-card class="form-card elevation-10">
         <div class="header-container">
  <!-- Botão de Transferências com dropdown -->
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn text color="primary" class="transfer-btn" v-bind="attrs" v-on="on">
        <v-icon left>mdi-transfer</v-icon>
        Transferências
        <v-icon right>mdi-menu-down</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item to="pedidos-transferencia">
        <v-list-item-icon>
          <v-badge color="green" :content="receivedRequests.length">
            <v-icon>mdi-inbox-arrow-down</v-icon>
          </v-badge>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Pedidos Recebidos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="solicitacoes-transferencia-enviada">
        <v-list-item-icon>
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Solicitações Enviadas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>

  <!-- Título da página -->
  <h2 class="title">Solicitar Transferência</h2>
</div>
 



      <!-- Formulário para solicitar transferência -->
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="save">
        <v-card-text>
          <v-container>
            <v-row>
              <!-- Campo de pesquisa de estudante -->
              <v-col cols="4">
                <v-autocomplete v-model="selectedStudent" :items="studentsList" :search-input.sync="search"
                  :loading="isSearching" color="primary" item-text="nome_idMatricula" item-value="id"
                  label="Pesquisar por nome ou matrícula" append-icon="mdi-magnify" return-object outlined
                  @change="selectStudent" clearable no-data-text="Nenhum estudante encontrado" required
                  :rules="[v => !!v || 'Campo obrigatório!']"></v-autocomplete>
              </v-col>

              <!-- Campos desabilitados para exibir informações do estudante -->
              <v-col cols="4">
                <v-text-field v-model="formData.idMatricula" :disabled="true" label="Matrícula" outlined required
                  :rules="[v => !!v || 'Campo obrigatório!']"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="formData.turma" :disabled="true" label="Turma" outlined required
                  :rules="[v => !!v || 'Campo obrigatório!']"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="formData.curso" :disabled="true" label="Curso" outlined required
                  :rules="[v => !!v || 'Campo obrigatório!']"></v-text-field>
              </v-col>

              <!-- Combobox para selecionar a instituição de destino -->
              <v-col cols="6">
                <v-combobox v-model="formData.instituicaoAll" :items="institutions" item-text="descricao" :disabled="isSearching"
                  item-value="idInstituicao" label="Selecione a instituição de destino" outlined return-object required
                  :rules="[v => !!v || 'Campo obrigatório!']"></v-combobox>
              </v-col>
            </v-row>
          </v-container>

          <!-- Botão de ação para continuar -->
         <v-card-actions>
  <v-spacer></v-spacer>
  <v-btn
    type="submit"
    color="success"
    class="continue-btn animated-btn"
    :disabled="isSaveDisabled"
  >
    Continuar
    <v-icon right>mdi-arrow-right</v-icon>
  </v-btn>
</v-card-actions>

        </v-card-text>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from '../../../plugins/axios';
import Swal from 'sweetalert2';
const ls = require('local-storage');

export default {
  data: () => ({
    selectedStudent: null,
    studentsList: [],
    search: "",
    isLoading: false,
    isSearching: false,
    valid: true,
    formData: {
      idMatricula: null,
      turma: null,
      curso: null,
      instituicaoAll: null
    },
    receivedRequests: [],
    institutions: [],
    isSaveDisabled: false
  }),

  watch: {
    // Observa o campo de pesquisa para carregar estudantes dinamicamente
    search(val) {
      if (val && val.length > 2) {
        if(!this.selectedStudent) {
          this.searchStudents(val);

        }
        
      } else {
        this.studentsList = [];
        this.isSearching = false;
        this.resetForm();
      }
    },
  },

  created() {
    // Inicializa as instituições e a lista de pedidos de transferência ao criar o componente
    this.initializeInstitutions();
    this.fetchReceivedRequests();
  },

  methods: {
    // Carrega a lista de instituições disponíveis
    async initializeInstitutions() {
      try {
        this.institutions = await axios.get('/listarInstituicao').then(res => res.data);
        // Filtra a instituição atual da lista
        this.institutions = this.institutions.filter(t => t.descricao !== ls.get('instituicaodescricao'));
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar as instituições!', 'error');
      } finally {
      }
    },

    // Carrega a lista de pedidos de transferência recebidos
    async fetchReceivedRequests() {
      this.isLoading = true;
      try {
        this.receivedRequests = await axios.get('/Listar_solicitacoes').then(res => res.data);
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao efectuar a operação', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    // Pesquisa estudantes com base no termo digitado
    async searchStudents(searchTerm) {
      this.isSearching = true;
      
      try {

        let payload = searchTerm ? `{ "find": "${searchTerm}" }` : '{ "find": "all" }';
        const response = await axios.get(`/PesquisaEstudanteTransferencia/${payload}`);
        // Formata a lista de estudantes para exibição no autocomplete
        this.studentsList = response.data.map(student => ({
          ...student,
          nome_idMatricula: `${student.nome} - ${student.idMatricula}`,
        }));

      } catch (error) {
        Swal.fire("Informação", "Ocorreu um erro durante a pesquisa do estudante!", "error");
      } finally {
        this.isSearching = false;
      }
    },

    // Preenche os campos do formulário com os dados do estudante selecionado
    selectStudent() {

      if (this.selectedStudent) {
        try {
          this.formData = { ...this.selectedStudent };
          // Verifica se o estudante já tem uma transferência pendente
          this.checkPendingTransfers(this.formData.idMatricula);
        } catch (error) {
          Swal.fire('Informação', 'Erro ao selecionar o estudante!', 'error');
        } finally {
        }
      }
    },

    // Verifica se o estudante já tem uma transferência pendente
    async checkPendingTransfers(matricula) {
      try {
        const response = await axios.get(`/verificarTransferenciaActiva/${matricula}`);
        if (response.data.length) {
          Swal.fire('Informação', 'O estudante já tem uma transferência pendente. Verifique as solicitações enviadas ou contate os administradores!', 'info');
          this.isSaveDisabled = true;
        } else {
          this.isSaveDisabled = false;
        }
      } catch (error) {
        Swal.fire('Informação', 'Erro ao verificar transferèncias pendentes do estudante!', 'error');
      } finally {
      }
    },

    // Salva a solicitação de transferência
    async save() {
      if (this.$refs.form.validate()) {
        const ls = require('local-storage');
        let params = {
          idInscricao_na_turma: this.formData.idInscricao_na_turma,
          fkPessoa: this.formData.pkPessoa,
          nomeEstudante: this.formData.nome,
          autor: ls.get('idPessoa'),
          idMatricula: this.formData.idMatricula,
          instituicaodestino: this.formData.instituicaoAll.idInstituicao,
          nomeinstituicaodestino: this.formData.instituicaoAll.descricao,
          idCurso: this.formData.idCurso,
          idanoacademico: this.formData.idClasse,
          observacao: '',
          pendente: ls.get('i_id') == 144 || ls.get('i_id') == 1 ? 1 : 0
        };

        // Conteúdo HTML personalizado para o modal de confirmação
        let htmlContent = `
                 ${params.pendente == 0 ? // Condição para exibir a linha do OBS
            `<p style="text-align: center;">
                    <strong style="color: red;">OBS:</strong> Ao confirmar, sua solicitação será enviada ao ${ls.get('ims')}. Após a autorização, seguirá para a instituição de destino.
                </p>` : ''
          }
                <div style="width: 100%; max-width: 400px; margin: 0 auto; text-align: left;">
                    <div style="display: grid; grid-template-columns: 150px auto; gap: 5px;">
                        <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Estudante:</strong></div>
                        <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${params.nomeEstudante} </div>
                        <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Matrícula:</strong></div>
                        <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${params.idMatricula} </div>
                        <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Destino:</strong></div>
                        <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${params.nomeinstituicaodestino}</div>
                        <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Autor:</strong></div>
                        <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${ls.get('nomeUsuario')}</div>
                    </div>
                </div>
                <label for="swal-input" style="display:block; margin-top:10px;"><strong>Motivo da transferência</strong><span style="color:red">*</span></label>
                <input id="swal-input" class="swal2-input" autocomplete="off" placeholder="Digite o motivo aqui..." style="width: 70%;">
            `;

        try {
          // Exibe o modal de confirmação com SweetAlert2
          Swal.fire({
            title: "Solicitar Transferência",
            html: htmlContent,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "red",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Solicitar",
            reverseButtons: true,
            position: "center",
            customClass: {
              popup: "no-scroll-popup"
            },
            preConfirm: () => {
              let observacao = document.getElementById("swal-input").value.trim();
              if (!observacao) {
                Swal.showValidationMessage("O motivo da transferência é obrigatório!");
                return false;
              }
              params.observacao = observacao;
            }
          }).then(async (result) => {
            if (result.isConfirmed) {
              // Envia a solicitação de transferência
              let mensagem = await axios.post('/SolicitarTransferencia', params).then(res => res);
              if (mensagem.status == 200) {
                if (params.pendente == 1) {
                  Swal.fire('Informação', 'Transferência enviada com sucesso!', 'success');
                } else {
                  Swal.fire('Informação', `Sua solicitação foi enviada ao ${ls.get('ims')}. Após a autorização, seguirá para a instituição de destino!`, 'success');
                }
                this.resetForm();
              } else {
                Swal.fire('Informação', 'Ocorreu um erro ao tentar solicitar a transferência', 'error');
              }
            }
          });
        } catch (error) {
          Swal.fire('Informação', 'Erro ao realizar a operação!', 'error');
        } finally {
          this.isLoading = false;
        }
      }
    },

    // Reseta o formulário para o estado inicial
    resetForm() {
      this.formData = { ...this.defaultItem };
      this.selectedStudent = null;
      this.studentsList = [];
      this.search = "";
      this.$refs.form.resetValidation();
    }
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f5f5f5;
}

.header-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 5px 25px;
  align-items: center;
}

.form-card {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.title {
   font-weight: bold;
  font-size: 24px;
}

.animated-btn {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.animated-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.no-scroll-popup {
  overflow: hidden;
}

 

 .header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 10px;
}

.title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
}

.transfer-btn {
  font-size: 0.9rem;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  text-transform: none;
}




.continue-btn {
  font-size: 1rem;
  padding: 10px 20px;
  border-radius: 8px;
  text-transform: none;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.continue-btn:hover {
  background-color: #2e7d32 !important; /* Um verde mais escuro no hover */
  transform: scale(1.05); /* Efeito sutil de crescimento */
}

.continue-btn:disabled {
  background-color: #a5d6a7 !important;
  cursor: not-allowed;
}


</style>